import html2pdf from 'html2pdf.js'

export const savePDF = (el: Element) => {
  html2pdf(el, {
    filename: '스키마 검사결과.pdf',
    jsPDF: {
      unit: 'px',
      format: [
        Math.max(document.documentElement.clientWidth, 375),
        document.documentElement.scrollHeight + 20,
      ],
    },
    html2canvas: {
      letterRendering: true,
      useCORS: true,
    },
  })
}
